var _path, _path2, _circle, _path3, _path4, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30L60 89",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4062 43.9375L68.5 47.4375C67.3958 45.5208 66.3438 44.2708 65.3438 43.6875C64.3021 43.0208 62.9583 42.6875 61.3125 42.6875C59.2917 42.6875 57.6146 43.2604 56.2812 44.4062C54.9479 45.5312 54.2812 46.9479 54.2812 48.6562C54.2812 51.0104 56.0312 52.9062 59.5312 54.3438L64.3438 56.3125C68.2604 57.8958 71.125 59.8333 72.9375 62.125C74.75 64.3958 75.6562 67.1875 75.6562 70.5C75.6562 74.9375 74.1771 78.6042 71.2188 81.5C68.2396 84.4167 64.5417 85.875 60.125 85.875C55.9375 85.875 52.4792 84.6354 49.75 82.1562C47.0625 79.6771 45.3854 76.1875 44.7188 71.6875L52.0938 70.0625C52.4271 72.8958 53.0104 74.8542 53.8438 75.9375C55.3438 78.0208 57.5312 79.0625 60.4062 79.0625C62.6771 79.0625 64.5625 78.3021 66.0625 76.7812C67.5625 75.2604 68.3125 73.3333 68.3125 71C68.3125 70.0625 68.1771 69.2083 67.9062 68.4375C67.6562 67.6458 67.25 66.9271 66.6875 66.2812C66.1458 65.6146 65.4375 65 64.5625 64.4375C63.6875 63.8542 62.6458 63.3021 61.4375 62.7812L56.7812 60.8438C50.1771 58.0521 46.875 53.9688 46.875 48.5938C46.875 44.9688 48.2604 41.9375 51.0312 39.5C53.8021 37.0417 57.25 35.8125 61.375 35.8125C66.9375 35.8125 71.2812 38.5208 74.4062 43.9375Z",
    fill: "#6ECDA9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 57,
    stroke: "#6ECDA9",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 59C18.5 33 38 17 59.5 18",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 61C102.5 87 83 103 61.5 102",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 19.5,
    r: 2.5,
    fill: "#6ECDA9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 100.5,
    r: 2.5,
    transform: "rotate(180 54.5 100.5)",
    fill: "#6ECDA9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.9e1d1d0b033e7afc5e1b7e8a79741c87.svg";
export { ForwardRef as ReactComponent };